/* Pistacho — o 3D no cartao (grelha de noite).

   No computador, com o rato por cima de um cartao que tenha a camada
   [data-card-3d] (snippet card-3d), o modelo aparece por cima da fotografia e
   roda devagar; ao sair, apaga-se e a fotografia volta.

   - So com rato de verdade: `(hover: hover) and (pointer: fine)`. No telemovel
     nao ha hover, e um toque abre a ficha, que ja tem o 3D.
   - Quem pede movimento reduzido nao tem rotacao, e portanto nao tem nada.
   - Nada e pedido enquanto ninguem se demora: 180 ms de rato parado no cartao
     antes de pedir a biblioteca e o GLB. Varrer a grelha com o rato nao
     descarrega nada.
   - O modelo nao recebe o rato (pointer-events: none): o cartao continua a ser
     um link, e a roda continua a descer a pagina.
   - A biblioteca entra por <script type="module"> e nao por import(): o
     Shopify minifica os assets e transforma import() em require() (ver
     pdp-2.js). Se a pagina ja tiver um model-viewer registado, usa-se esse.
   - Os cartoes podem ser trocados pelos filtros sem recarregar a pagina: os
     eventos ouvem-se no documento, e o estado vive em cada camada. */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ORBITA = '20deg 78deg auto';
  var biblioteca = null;

  function carregarBiblioteca(url) {
    if (biblioteca) return biblioteca;
    biblioteca = new Promise(function (ok, falha) {
      if (window.customElements && customElements.get('model-viewer')) { ok(); return; }
      if (url.indexOf('//') === 0) url = location.protocol + url;
      var s = document.createElement('script');
      s.type = 'module';
      s.src = url;
      s.onerror = falha;
      document.head.appendChild(s);
      customElements.whenDefined('model-viewer').then(ok);
    });
    return biblioteca;
  }

  function camadaDe(el) {
    var cartao = el && el.closest && el.closest('.card-container');
    return cartao ? cartao.querySelector('[data-card-3d]') : null;
  }

  function criar(camada) {
    var tpl = camada.querySelector('[data-card-3d-tpl]');
    var modelo = tpl && tpl.content.querySelector('model-viewer');
    if (!modelo) return null;
    var vista = modelo.cloneNode(true);
    vista.removeAttribute('poster');
    vista.removeAttribute('data-shopify-feature');
    vista.removeAttribute('camera-controls');
    vista.setAttribute('loading', 'eager');
    vista.setAttribute('reveal', 'auto');
    vista.addEventListener('load', function () {
      clearTimeout(camada._espera);
      camada._pronta = true;
      if (camada._dentro) mostrar(camada);
    });
    vista.addEventListener('error', function () { desistir(camada); });
    camada.appendChild(vista);
    return vista;
  }

  function desistir(camada) {
    clearTimeout(camada._espera);
    camada._falhou = true;
    camada.classList.remove('card-3d--ativa');
    if (camada._vista) camada._vista.remove();
    camada._vista = null;
    camada.hidden = true;
  }

  function mostrar(camada) {
    var vista = camada._vista;
    if (!vista) return;
    vista.cameraOrbit = ORBITA;
    if (typeof vista.jumpCameraToGoal === 'function') vista.jumpCameraToGoal();
    vista.setAttribute('auto-rotate', '');
    camada.classList.add('card-3d--ativa');
  }

  function entrar(camada) {
    camada._dentro = true;
    if (camada._falhou) return;
    if (camada._pronta) { mostrar(camada); return; }
    clearTimeout(camada._demora);
    camada._demora = setTimeout(function () {
      if (!camada._dentro || camada._vista) return;
      camada.hidden = false;
      // uma rede lenta nao pode deixar o cartao a meio para sempre
      camada._espera = setTimeout(function () { desistir(camada); }, 30000);
      carregarBiblioteca(camada.getAttribute('data-card-3d-lib') || '').then(function () {
        if (!camada._vista && !camada._falhou) camada._vista = criar(camada);
        if (!camada._vista) desistir(camada);
      }, function () { desistir(camada); });
    }, 180);
  }

  function sair(camada) {
    camada._dentro = false;
    clearTimeout(camada._demora);
    camada.classList.remove('card-3d--ativa');
    // parar a rotacao quando ja nao se ve: nao gastar GPU num cartao apagado
    setTimeout(function () {
      if (!camada._dentro && camada._vista) camada._vista.removeAttribute('auto-rotate');
    }, 400);
  }

  document.addEventListener('mouseover', function (e) {
    var camada = camadaDe(e.target);
    if (!camada || camada._dentro) return;
    entrar(camada);
  });
  document.addEventListener('mouseout', function (e) {
    var camada = camadaDe(e.target);
    if (!camada || !camada._dentro) return;
    // mouseout dispara ao passar entre filhos do cartao; so conta sair dele
    var para = e.relatedTarget;
    if (para && camadaDe(para) === camada) return;
    sair(camada);
  });
})();
